/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function GetDimensionTagsWithDataRequestFromJSON(json) {
    return GetDimensionTagsWithDataRequestFromJSONTyped(json, false);
}
export function GetDimensionTagsWithDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        accountTagIds: json['accountTagIds'],
        compoundExpression: json['compoundExpression'],
        tableTagId: json['tableTagId'],
    };
}
export function GetDimensionTagsWithDataRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        accountTagIds: value.accountTagIds,
        compoundExpression: value.compoundExpression,
        tableTagId: value.tableTagId,
    };
}
